import React from 'react';

import { ColContainer } from './components/atoms';
import { Title, SectionList } from './components/molecules';
import List from './list';

function Home() {
  return (
    <React.Fragment>
      <ColContainer
        w='100%'
        h='100vh'
        style={{
          paddingTop: '10vh',
          minHeight: '100vh',
        }}
      />
      <Title />
      <SectionList list={List} />
    </React.Fragment>
  );
}

export default Home;
